// Přebírá se z .env.development (localhost) / .env.production (https://domik.cz).
export const serverUrl =
  process.env.REACT_APP_SERVER_URL || "https://localhost:44313";
